import { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import { useCommentsStore } from '@editorStores'
import { useSelectedPlanElementId } from '@editorHooks'
import CommentSettingsPanel from './CommentSettingsPanel'

interface Props {
  /** Shows a close button in the form's header when given. */
  onClose?: () => void
}

/**
 * Drawer shown next to the comments list (only while the "Kommentare" tab is active). It surfaces
 * the selected comment's settings — the same controls as the in-scene CommentEditPopup — so they
 * can be edited beside the list instead of in the scene. With no comment selected it prompts the
 * user to pick one.
 */
const CommentDrawer = ({ onClose }: Props): ReactElement => {
  const comments = useCommentsStore(state => state.comments)
  const selectedId = useSelectedPlanElementId('comment')

  const selectedComment = selectedId ? comments.find(comment => comment.id === selectedId) : null

  if (!selectedComment) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary" data-cy="comment-drawer-empty">
          Bitte einen Kommentar auswählen
        </Typography>
      </Box>
    )
  }

  return (
    <CommentSettingsPanel key={selectedComment.id} comment={selectedComment} onClose={onClose} />
  )
}

export default CommentDrawer
